import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ArrowRight } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <main
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        background: 'var(--hj-bg)',
        color: 'var(--hj-ink)',
      }}
    >
      <div className="text-center" style={{ maxWidth: 520 }}>
        <div
          className="mono-label"
          style={{ marginBottom: 16, color: 'var(--hj-ink-3)' }}
        >
          404 · not found
        </div>
        <h1
          className="font-hj-display m-0"
          style={{
            fontSize: 'clamp(56px, 9vw, 96px)',
            lineHeight: 0.94,
            color: 'var(--hj-ink)',
            letterSpacing: '-0.035em',
          }}
        >
          Wrong&nbsp;
          <span
            style={{
              position: 'relative',
              display: 'inline-block',
              padding: '0.04em 0.18em',
              background: 'var(--hj-yellow)',
              color: 'oklch(0.18 0.005 70)',
              clipPath: 'polygon(2% 8%, 98% 0%, 100% 92%, 0% 100%)',
              transform: 'rotate(-1.5deg)',
            }}
          >
            take.
          </span>
        </h1>
        <p
          className="m-0"
          style={{
            marginTop: 18,
            color: 'var(--hj-ink-3)',
            fontSize: 15,
            lineHeight: 1.5,
          }}
        >
          We couldn't find that page. The link may be old, or the URL is off by a character.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-1.5"
          style={{
            marginTop: 28,
            padding: '12px 22px',
            borderRadius: 999,
            background: 'var(--hj-blue)',
            border: '1px solid var(--hj-blue)',
            color: 'oklch(0.18 0.005 70)',
            fontSize: 14,
            fontWeight: 700,
            textDecoration: 'none',
            minHeight: 44,
          }}
        >
          Back to home
          <ArrowRight size={14} strokeWidth={2.4} />
        </Link>
      </div>
    </main>
  );
};

export default NotFound;
